import * as React from "react";
import { Row, Spin } from 'antd';
import { SpecialProjectCommissionSliderComponent } from 'src/components/PricingComponents/SpecialProjectCommissionSliderComponent/SpecialProjectCommissionSliderComponent'
import Form, { FormComponentProps, WrappedFormUtils } from 'antd/lib/form/Form';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useContext } from 'react';
import { AuthContext } from 'src/components/context/AuthContext';
import { ITrade } from 'src/services/interfaces/trade/ITrade';
import StandardButton from '../StandardButton/StandardButton';
import { ShowNotification } from '../ShowNotification/ShowNotification';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ISpecialProjectCommissionRange } from 'src/services/interfaces/ISpecialProjectCommissionRange';
import { CommissionMetodologyEnum } from 'src/services/interfaces/CommissionMetodologyEnum';
import ViewExceedMaxPriceBalanceButton from "./ExceedMaxPriceBalance/ViewExceedMaxPriceBalanceButton";
import * as _ from 'lodash';
import { IPricingUpdateRequest } from "src/services/interfaces/calculator/ISpecialProjectPricingUpdateRequest";


interface ICommissionBody {
  currentTrade: ITrade;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  reloadTrade: (tradeID: number) => void;
  form: WrappedFormUtils;
}

export const CommissionBody: React.FC<ICommissionBody & FormComponentProps> = ({ currentTrade, setShowModal, reloadTrade, form }) => {
  const { currentUser } = useContext(AuthContext);
  const { pricingService, specialProjectCommissionService } = useContext(ServiceContext);
  const [loading, setLoading] = useState(false);
  const [priceRequest, setPrice] = useState(0);
  const [commissionRequest, setCommission] = useState(0);
  const [commissionRange, setCommissionRange] = useState<ISpecialProjectCommissionRange>({
    minCommission: 0,
    maxCommission: 0,
    minPrice: 0,
    maxPrice: 0,
    commission: 0,
    price: 0,
    metodology: CommissionMetodologyEnum.OriginalPrice,
    kicker: 0,
    baseCommission: 0,
    exceedMaxPriceBalance: null,
    provisionedAmount: 0
  })

  useEffect(() => {
    if (currentTrade.id !== 0) {
      getUserCommissionParameters(currentTrade.id);
    }
  }, [currentTrade.id]);



  useEffect(() => {
    if (commissionRange.price !== 0) {
      setPrice(commissionRange.price);
      setCommission(commissionRange.commission);
      handleChangeCommission(commissionRange.commission);
    }
  }, [commissionRange]);

  function getUserCommissionParameters(tradeId: number) {
    setLoading(true);
    specialProjectCommissionService
      .getRangeCalculated(tradeId)
      .then(resp => setCommissionRange(resp))
      .catch()
      .finally(() => setLoading(false));
  }

  function UpdateTrade() {
    setLoading(true);
    const request: IPricingUpdateRequest = {
      idTrade: currentTrade.id,
      price: priceRequest,
      commission: commissionRequest
    };
    pricingService
      .updatePricing(request)
      .then(() => {
        ShowNotification.Success("Sucesso!", "Dados do trade alterado com sucesso");
        reloadTrade(currentTrade.id);
      })
      .catch(error => {
        ShowNotification.Error("Erro ao atualizar Trade", error.response.data);
      })
      .finally(() => {
        setShowModal(false);
        setLoading(false)
      });
  }

  function handleChangeCommission(commissionValue) {
    if (_.isEmpty(commissionRange.exceedMaxPriceBalance)) {

      let price = 0;
      if (commissionRange.metodology === CommissionMetodologyEnum.OriginalPrice) {
        price = ((commissionValue - commissionRange.minCommission) * (commissionRange.minPrice - commissionRange.maxPrice)) / (commissionRange.maxCommission - commissionRange.minCommission) + commissionRange.maxPrice;
      } else {
        price = (commissionValue - commissionRange.maxPrice * commissionRange.kicker) / (commissionRange.baseCommission - commissionRange.kicker)
      }
      form.setFieldsValue({
        commission: commissionValue,
        price
      });
      setPrice(price);
      setCommission(commissionValue);
    }
  }

  function handleChangePrice(price) {
    let commissionValue = 0;
    const baseCommission = price > commissionRange.maxPrice ? commissionRange.exceedMaxPriceBalance?.commissionPercentage : commissionRange.baseCommission;
    const kicker = price > commissionRange.maxPrice ? 0 : commissionRange.kicker;
    const baseCommissionPrice = commissionRange.metodology === CommissionMetodologyEnum.OriginalPrice ? commissionRange.maxPrice : price

    commissionValue = ((commissionRange.maxPrice - price) * kicker) + (baseCommissionPrice * baseCommission);
    form.setFieldsValue({
      commission: commissionValue,
      price
    });
    setPrice(price);
    setCommission(commissionValue);
  }

  const isSliderPriceDisabled = () => commissionRange.minCommission === 0 && commissionRange.maxPrice === 0;
  const isSliderCommissionDisabled = () => commissionRange.minCommission === 0 && commissionRange.maxCommission === 0;

  return (
    <React.Fragment>
      <Spin spinning={loading}>
        <Row gutter={16}>
          <SpecialProjectCommissionSliderComponent
            provisionedAmount={commissionRange.provisionedAmount}
            balance={commissionRange.exceedMaxPriceBalance}
            form={form}
            minPrice={commissionRange.minPrice}
            maxPrice={commissionRange.maxPrice}
            price={priceRequest}
            minCommission={commissionRange.minCommission}
            maxCommission={commissionRange.maxCommission}
            commission={commissionRequest}
            handleChangePrice={handleChangePrice}
            handleChangeCommission={handleChangeCommission}
            disableCommissionSlider={isSliderCommissionDisabled() || !_.isEmpty(commissionRange.exceedMaxPriceBalance)}
            canEditQuotePrice={currentUser.permissions.canEditQuotePrice}
          />
        </Row>
        <Row gutter={16} style={{ marginTop: "20px" }}>
          <div className="button-save">
            <StandardButton
              onClick={e => UpdateTrade()}
              loading={loading}
              disabled={
                isSliderPriceDisabled() ||
                isSliderCommissionDisabled()
              }
            >
              Salvar
            </StandardButton>
            {commissionRange.exceedMaxPriceBalance &&
              <ViewExceedMaxPriceBalanceButton id={commissionRange.exceedMaxPriceBalance.id} />
            }
          </div>
        </Row>
      </Spin>
    </React.Fragment >
  );
}

export default Form.create()(CommissionBody);



// WEBPACK FOOTER //
// ./src/components/common/CommissionView/ViewTradeCommissionModal.tsx